import {handleActions} from 'redux-actions';
import _ from 'lodash';

import actions from '../actions/agent/change.type';
import api_actions from '../actions/api';
import redirect from '../../utils/redirect';

export default handleActions({
    [actions.change_type_submit]: (state, action) => {
        switch (action.payload) {
            case api_actions.api_start:
                return {
                    ...state,
                    isLoading: true,
                    errors: {},
                    results: {},
                };
            case api_actions.api_end:
                return {
                    ...state,
                    isLoading: false,
                };
            default:
                return state;
        }
    },
    [actions.change_type_failed]: (state, action) => {
        const errors = _.get(action, 'payload.data.error');
        return {
            ...state,
            errors:errors,
        };
    },
    [actions.change_type_reset]: (state, action) => {
        return getDefaults();
    }
}, getDefaults());

export function getDefaults() {
    return {
        isLoading: false,
        errors: {},
        new_type: null,
        redirect_path: null,
    };
}

export const handleChangeTypeSucceeded = (state, action) => {
    const {type, uuid} = action.payload;
    return {
        ...state,
        [type]: {
            ...state[type],
            [uuid]: {
                ...state[type][uuid],
                data: action.payload
            },
        },
        changeType: {...state.changeType, ...redirect.add(`/${type}/${uuid}`),  new_type: type,},
    };
};
